import { Download, X } from "lucide-react";
import { usePWAInstall } from "@/hooks/usePWAInstall";
import { Button } from "@/components/ui/button";

export function PWAInstallPrompt() {
  const { showPrompt, install, dismiss } = usePWAInstall();

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 w-[320px] max-w-[calc(100vw-2rem)] animate-in slide-in-from-bottom-4 fade-in duration-300">
      <div className="rounded-lg border bg-card p-4 shadow-lg">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary/10">
            <Download className="h-5 w-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-card-foreground">Install St. David SMS</p>
            <p className="text-xs text-muted-foreground mt-0.5">
              Get quick access from your home screen with offline support.
            </p>
            <div className="flex items-center gap-2 mt-3">
              <Button size="sm" onClick={install} className="h-8 text-xs gap-1.5">
                <Download className="h-3.5 w-3.5" />
                Install App Now
              </Button>
              <Button size="sm" variant="ghost" onClick={dismiss} className="h-8 text-xs text-muted-foreground">
                Not now
              </Button>
            </div>
          </div>
          <button
            onClick={dismiss}
            className="shrink-0 rounded-sm p-0.5 text-muted-foreground hover:text-foreground transition-colors"
            aria-label="Dismiss install prompt"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
